import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: $setup.dialog,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.dialog) = $event)),
    "max-width": "600"
  }, {
    activator: _withCtx(({ props: activatorProps }) => [
      _createVNode(_component_v_chip, _mergeProps(activatorProps, {
        color: "blue",
        variant: "flat",
        size: "small"
      }), {
        default: _withCtx(() => [
          _createTextVNode("Költséghelyek")
        ]),
        _: 2
      }, 1040)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        title: `Költséghelyek - ${$props.userName}`
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_data_table, {
                modelValue: $setup.selectedIds,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedIds) = $event)),
                headers: $setup.headers,
                items: $setup.allCostCenters,
                loading: $setup.loading,
                "item-value": "id",
                "show-select": "",
                density: "compact"
              }, null, 8, ["modelValue", "items", "loading"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                variant: "text",
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.dialog = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Mégse")
                ]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                color: "primary",
                onClick: $setup.save
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Mentés")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}